<template>
  <SidebarComponent /> <!-- Import the sidebar as requested -->
  <div class="dashboard-layout">
    <div class="content-container">
      <div class="titolo-card">
        <h1>Utenti con Privacy Accettata</h1>
      </div>

      <!-- Date Filter Inputs -->
      <div class="filter-container">
        <div class="filter-item">
          <label for="fromDate">Dal Giorno:</label>
          <input type="date" v-model="fromDate" id="fromDate" />
        </div>

        <div class="filter-item">
          <label for="toDate">Al Giorno:</label>
          <input type="date" v-model="toDate" id="toDate" />
        </div>

        <button @click="applyDateFilter" class="filter-button">Filtra</button>
      </div>

      <!-- Pulsante per alternare tra utenti visibili e nascosti -->
  <button @click="toggleHiddenUsers" class="filter-button">
    {{ showHiddenUsers ? 'Mostra utenti visibili' : 'Mostra utenti nascosti' }}
  </button>

  <button @click="goToUsersList" class="filter-button">
    Ricerca utenti
  </button>

      <!-- Table displaying users with accepted privacy -->
      <table>
        <thead>
          <tr>
            <th>Email</th>
            <th>Nome</th>

            <th>Data Privacy Accettata</th>
            <th>Azioni</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(user, index) in filteredUsers" :key="index">
            <td>{{ user.email }}</td>
            <td>{{ user.name }} {{ user.surname }}</td>

            <td>{{ formatDate(user.dataPrivacyAccettata) }}</td>
            <td>
  <div class="buttons-container">
    <button @click="viewUserDetails(user.uid)">
      <span class="material-icons">visibility</span>
    </button>
    <!-- Nuovo pulsante per nascondere l'utente -->
    <button @click="hideUser(user)">
      <span class="material-icons">remove_circle</span> <!-- Icona di rimozione -->
    </button>
  </div>
</td>

          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { getFirestore, collection, getDocs, query, where, orderBy, doc, updateDoc } from 'firebase/firestore';
import SidebarComponent from '../SidebarComponent.vue';

export default {
  components: {
    SidebarComponent
  },
  setup() {
    const users = ref([]);
    const filteredUsers = ref([]);
    const fromDate = ref('');
    const toDate = ref('');
    const db = getFirestore();
    const router = useRouter();
    const showHiddenUsers = ref(false); // Variabile per alternare tra visibili/nascosti


        // Funzione per reindirizzare alla lista degli utenti
        const goToUsersList = () => {
      router.push('/users-list'); // Naviga a '/users-list'
    };


    const hideUser = async (user) => {
  // Determina se l'utente è nascosto o visibile
  const newHiddenState = !user.hidden;

  // Aggiorna lo stato locale dell'utente
  user.hidden = newHiddenState;

  // Aggiorna il database, invertendo lo stato di 'hidden'
  const userRef = doc(db, 'users', user.uid);
  try {
    await updateDoc(userRef, {
      hidden: newHiddenState ? true : false // Aggiorna il campo 'hidden'
    });
    applyDateFilter(); // Ricalcola il filtro per mostrare/nascondere l'utente
  } catch (error) {
    console.error('Errore durante l\'aggiornamento del database:', error);
  }
};


    // Funzione per alternare la visualizzazione tra utenti nascosti e visibili
    const toggleHiddenUsers = () => {
      showHiddenUsers.value = !showHiddenUsers.value;
      applyDateFilter(); // Ricalcola il filtro per mostrare/nascondere utenti
    };

    // Funzione per filtrare i dati localmente, inclusi gli utenti nascosti
    const applyDateFilter = () => {
      const from = fromDate.value ? new Date(fromDate.value) : null;
      const to = toDate.value ? new Date(toDate.value) : null;

      filteredUsers.value = users.value.filter(user => {
        const userDate = new Date(user.dataPrivacyAccettata);

        // Se 'showHiddenUsers' è attivo, mostra solo gli utenti nascosti
        if (showHiddenUsers.value) {
          if (!user.hidden) return false; // Mostra solo gli utenti nascosti
        } else {
          if (user.hidden) return false; // Escludi gli utenti nascosti
        }

        if (from && to) {
          return userDate >= from && userDate <= to;
        } else if (from) {
          return userDate >= from;
        } else if (to) {
          return userDate <= to;
        } else {
          return true;
        }
      });
    };

    // Quando i dati degli utenti vengono recuperati, escludi quelli nascosti localmente
    const fetchUsersWithPrivacyAccepted = async () => {
      const q = query(
        collection(db, "users"),
        where("privacyAccettata", "==", true),
        orderBy("dataPrivacyAccettata", "asc") // Usa l'indice esistente
      );

      const querySnapshot = await getDocs(q);
      users.value = querySnapshot.docs.map(doc => ({
        uid: doc.id,
        hidden: doc.data().hidden || false, // Recupera lo stato 'hidden'
        ...doc.data()
      }));

      applyDateFilter(); // Applica il filtro iniziale per escludere gli utenti nascosti
    };


    // Format date for display
    const formatDate = (dateStr) => {
      const date = new Date(dateStr);
      return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
    };



    // Navigate to user details
    const viewUserDetails = (userId) => {
      router.push({ name: 'UserAlimentazione', params: { userId } });
    };

    // Fetch the users on component mount
    onMounted(fetchUsersWithPrivacyAccepted);

    return {
      users,
      filteredUsers,
      fromDate,
      toDate,
      formatDate,
      applyDateFilter,
      viewUserDetails,
      hideUser,
      toggleHiddenUsers, // Aggiungiamo la nuova funzione
      showHiddenUsers, // Aggiungiamo la nuova variabile
      goToUsersList
    };
  }
};
</script>

<style scoped>

.titolo-card {
  margin-bottom: 20px;
}

.filter-container {
  display: flex;
  align-items: flex-end; /* Align items to the bottom of the container */
  gap: 15px;
  margin-bottom: 20px;
}

.filter-item {
  display: flex;
  flex-direction: column;
}

.filter-button {
  background-color: #4CAF50;
  color: white;
  padding: 14px;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  align-self: flex-end; /* Align the button to the bottom */
  border-radius: 13px;
  margin-right: 20px;
}

table {
  width: 99%;
  margin-top: 20px;
}

th, td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.buttons-container {
  display: flex;
  gap: 10px;
}

</style>
